function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, onMounted, ref, computed } from "vue";
import { definePropType } from "@types-vue/props";
import { ElSchemaFormFieldset } from "el-schema-form";
import DurationFilter from "@pt/views/pt-entry/components/filter-bar/duration-filter.vue";
import BitrateFilter from "@pt/views/pt-entry/components/filter-bar/bitrate-filter.vue";
import SizeFilter from "@pt/views/pt-entry/components/filter-bar/size-filter.vue";
import ResolutionFilter from "@pt/views/pt-entry/components/filter-bar/resolution-filter.vue";
import TimeFilter from "@pt/views/pt-entry/components/filter-bar/time-filter.vue";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
export default defineComponent({
    components: {
        TimeFilter: TimeFilter,
        SizeFilter: SizeFilter,
        BitrateFilter: BitrateFilter,
        DurationFilter: DurationFilter,
        ResolutionFilter: ResolutionFilter,
        ElSchemaFormFieldset: ElSchemaFormFieldset
    },
    props: {
        model: {
            type: definePropType(Object),
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var formConfig = {
            inline: true
        };
        var isInit = ref(true);
        var visible = ref(true);
        var basicStyleFormItemList = computed(function() {
            var formModel = props.model;
            return [
                _objectSpreadProps(_objectSpread({}, filterSchemaConfig.directions), {
                    field: _objectSpreadProps(_objectSpread({}, filterSchemaConfig.directions.field), {
                        class: formModel.directions.length ? "select-valuable" : ""
                    })
                }),
                _objectSpreadProps(_objectSpread({}, filterSchemaConfig.ratios), {
                    field: _objectSpreadProps(_objectSpread({}, filterSchemaConfig.ratios.field), {
                        class: formModel.ratios.length ? "select-valuable" : ""
                    })
                }), 
            ];
        });
        var handleChange = function(value) {
            if (!isInit.value) {
                emit("change", value);
            }
        };
        onMounted(function() {
            setTimeout(function() {
                isInit.value = false;
            }, 300);
        });
        return {
            formConfig: formConfig,
            basicStyleFormItemList: basicStyleFormItemList,
            handleChange: handleChange,
            visible: visible
        };
    }
});
